const initPlayOnScroll = (videoElement) => {
    const $playBtn = $(videoElement).find(".play-icon");
    const $mutedBtn = $(videoElement).find(".muted-icon");
    const $video = $(videoElement).find("video");
    const elementTop = $(videoElement).offset().top;
    const elementBottom = elementTop + $(videoElement).height();
    let viewportBottom = $(window).height();
    $(window).on("scroll", function () {
        const scrollTop = $(window).scrollTop();

        if ((elementTop - scrollTop > viewportBottom / 2) || (elementTop - scrollTop < -viewportBottom / 2)) {
            let video = $video?.[0];
            video.pause();
        }
        else if (elementTop - scrollTop < viewportBottom / 2) {
            const isPlaying = !$video?.[0].paused;
            if($video.data('paused')) {
                let video = $video?.[0];
                $video.attr("controls", "controls");
                return video.pause();
            }
            if (!isPlaying) {
                let video = $video?.[0];
                return video.play().catch((e) => {
                    video.muted = true;
                    video.playsInline = true
                    video.play();
                })
            }
        }
    })
}

const videoPlayBtn = () => {
    $(".video-with-btn-play").each(function () {
        let $playBtn = $(this).find(".play-icon");
        let $mutedBtn = $(this).find(".muted-icon");
        if (!$playBtn.length) {
            $(this).append(`<div class="play-icon">&nbsp;</div>`)
            $playBtn = $(this).find(".play-icon");
        }
        if (!$mutedBtn.length) {
            $(this).append(`<div class="muted-icon">&nbsp;</div>`)
            $mutedBtn = $(this).find(".muted-icon");
        }

        const $video = $(this).find("video");
        const checkPlay = () => {
            const isPlaying = !$video?.[0].paused;
            if (!isPlaying) {
                $playBtn.show();
                $video.removeAttr("controls");
            }
            else {
                $playBtn.hide();
                $video.attr("controls", "controls")
            }
        }
        const checkMuted = () => {
            const isPlaying = !$video?.[0].paused;
            const isMuted = $video?.[0].muted;
            if (isPlaying && isMuted) {
                $mutedBtn.show();
            }
            else {
                $mutedBtn.hide();
            }
        }

        $video.on("play volumechange", function () {
            checkPlay();
            checkMuted();
        })

        $video.on("pause", function () {
            $(this).attr('data-paused', true);
            checkPlay();
            checkMuted();
        })

        $playBtn.on("click", function () {
            const video = $video?.[0];
            video.muted = false
            $video?.[0].play()
        })
        $mutedBtn.on("click", function () {
            const video = $video?.[0];
            video.muted = false
            $video?.[0].play()
        })
        if ($(this).data("play-on-scroll")) {
            initPlayOnScroll($(this))
        }
    })
}

module.exports = videoPlayBtn
